import { updateManagerPageStep } from "./managerPageWizardService";
import apiClient from "./ApiService";

/**
 * Guarda los datos del paso CICAC
 * - Envía al backend
 * - Actualiza ManagerPage
 */
// * - Actualiza ManagerPage
export async function saveCicacStep(idTransaction, data) {
  const dto = {
    idAdmin: idTransaction,
    allowUploadInfo: data.permisoCicac === "SI",
    reason:
      data.permisoCicac === "NO"
        ? data.razonNoAutorizacion
        : null,
  };
  try {
    await apiClient.post("/adelselfservice/selfservice/cicac", dto);
  } catch (e) {
    throw new Error("Error guardando CICAC");
  }
  await updateManagerPageStep(idTransaction, "cicac");
  return true;
}
export async function sendToAdel(idTransaction) {
  try {
    const result = await apiClient.post(
      `/adelselfservice/selfservice/adel/send/${idTransaction}`
    );

    console.log("RESULT:", result);

    return {
      success: true,
      message: result,
    };

  } catch (error) {
    console.log("ERROR COMPLETO:", error);
    console.log("ERROR RESPONSE:", error?.response);

    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.response?.data ||
        "Error enviando información a Adel",
    };
  }
}

/**
 * Obtiene los datos existentes de CICAC
 */
export async function getCicacStep(idAdmin) {
  try {
    const result = await apiClient.get(
      `/adelselfservice/selfservice/cicac/admin/${idAdmin}`
    );
    return result;
  } catch (e) {
    throw new Error("Error obteniendo CICAC");
  }
}